module.exports = __webpack_public_path__ + "img/WechatIMG28.ff2166d7.jpeg";